import { Component } from '@angular/core';

@Component({
  selector: 'app-pass-key-authenticate-form',
  templateUrl: './pass-key-authenticate-form.component.html',
  styleUrl: './pass-key-authenticate-form.component.scss',
  standalone: false
})
export class PassKeyAuthenticateFormComponent {

}
